import { administrationRequests } from "api/administrationApi";
import React from "react";
import { AutocompleteInput, ReferenceInput, required as raRequired } from "react-admin";

const DirectionInput = ({ handleChange, required, readOnly, filterOnlyForCampaigns, filterByUser }) => {
  return (
    <ReferenceInput
      source="directionId"
      filter={{ OnlyForCampaigns: filterOnlyForCampaigns ? true : false, FilterByUser: filterByUser ? true : false }}
      reference={administrationRequests.getDirectionsSelect()}
    >
      <AutocompleteInput
        validate={required ? [raRequired()] : []}
        label="Направление"
        optionText="name"
        optionValue="id"
        filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
        onChange={handleChange}
        readOnly={readOnly}
      />
    </ReferenceInput>
  );
};

export default DirectionInput;
